import React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Typography from "@mui/material/Typography";
import { theme } from "@answersnow/pkg-theme";
import { TAB_CONFIG } from "./constants";
import type { TaskType } from "./types";

interface TasksHeaderProps {
  selectedTab: TaskType;
  counts: Record<TaskType, number>;
  onChange: (tab: TaskType) => void;
}

export const TasksHeader: React.FC<TasksHeaderProps> = ({ selectedTab, counts, onChange }) => (
  <Grid
    xs={12}
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 2,
      px: "8px",
      py: 0,
    }}
    data-testid="client-tasks-header"
  >
    <Typography
      id="client-tasks-heading"
      component="h3"
      variant="h4"
      sx={{
        fontWeight: 500,
        fontSize: "18px",
        lineHeight: "1.6",
        letterSpacing: "0.12px",
        color: theme.palette.text.primary,
      }}
    >
      Client Tasks
    </Typography>

    <ToggleButtonGroup
      value={selectedTab}
      exclusive
      size="small"
      onChange={(_, newTab) => {
        if (newTab !== null) onChange(newTab);
      }}
      aria-label="Task filter"
      data-testid="task-filter-group"
      sx={{
        bgcolor: theme.palette.background.paper,
        border: "1px solid",
        borderColor: theme.palette.divider,
        borderRadius: "10px",
        p: 1,
        boxShadow: theme.shadows[1],
      }}
    >
      {TAB_CONFIG.map((tab) => (
        <ToggleButton
          key={tab.value}
          value={tab.value}
          aria-label={`Filter to ${tab.label.toLowerCase()}`}
          data-testid={`filter-${tab.value}`}
          sx={{
            textTransform: "none",
            fontSize: "13px",
            fontWeight: 500,
            lineHeight: "22px",
            letterSpacing: "0.46px",
            px: 2,
            py: 1,
            color: theme.palette.text.primary,
            "&.Mui-selected": {
              bgcolor: "#EAECEF",
              color: theme.palette.text.primary,
              "&:hover": {
                bgcolor: "#EAECEF",
              },
            },
            "&:not(.Mui-selected)": {
              color: theme.palette.text.primary,
              bgcolor: "transparent",
              "&:hover": {
                bgcolor: theme.palette.action.hover,
              },
            },
          }}
        >
          {tab.label} ({counts[tab.value]})
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  </Grid>
);
